var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.listLoading,
          expression: "listLoading",
        },
      ],
      staticClass: "red-packet-table-container",
    },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "序号" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入序号" },
                    model: {
                      value: _vm.searchForm.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "id", $$v)
                      },
                      expression: "searchForm.id",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入活动名称" },
                    model: {
                      value: _vm.searchForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "title", $$v)
                      },
                      expression: "searchForm.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("创建裂变活动")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning", size: "small" },
                      on: { click: _vm.handleTraffic },
                    },
                    [_vm._v("配置流量监控")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, stripe: "", border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              width: "100",
              prop: "idd",
              align: "center",
              fixed: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动名称",
              width: "200",
              prop: "title",
              align: "center",
              fixed: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "副标题",
              width: "200",
              prop: "subtitle",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动图",
              width: "100",
              prop: "activityImage",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-image", {
                      staticStyle: { width: "60px" },
                      attrs: {
                        src: _vm.imageAccessDomain + scope.row.activityImage,
                        alt: "活动图",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "邀请类型",
              width: "100",
              prop: "inviteTypeName",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "满足邀请人数",
              prop: "inviteCount",
              width: "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "库存数",
              prop: "availableStock",
              width: "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "已领取数(发起)",
              prop: "initiatorUsedStock",
              width: "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "已领取数(助力)",
              prop: "helperUsedStock",
              width: "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "拉新人数",
              prop: "newUserCount",
              width: "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "激活人数",
              prop: "activeUserCount",
              width: "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动时间",
              prop: "activityTimeFormatter",
              width: "180",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.startTimeFormatter) +
                        "\n        "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.endTimeFormatter) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动创建时间",
              prop: "createTimeFormatter",
              width: "180",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "启用开关",
              prop: "enabled",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.enabled
                      ? _c(
                          "el-tag",
                          { attrs: { type: "primary", size: "small" } },
                          [_vm._v("启用")]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "info", size: "small" } },
                          [_vm._v("禁用")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "380",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleCopyToCreate(scope.row)
                          },
                        },
                      },
                      [_vm._v("复制")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleQrCode(scope.row)
                          },
                        },
                      },
                      [_vm._v("二维码")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleActivityDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("活动明细")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes,prev, pager, next,jumper",
              "page-size": _vm.searchForm.limit,
              "page-sizes": [10, 20, 30, 50],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "配置流量监控",
            visible: _vm.trafficDialogVisible,
            width: "520px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.trafficDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模式" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.trafficForm.trafficMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.trafficForm, "trafficMode", $$v)
                        },
                        expression: "trafficForm.trafficMode",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "OFF" } }, [
                        _vm._v("关闭（关此配置，活动仍启用）"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "ALL" } }, [
                        _vm._v("全拦（所有活动的发起和助力）"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "RATE" } }, [
                        _vm._v("限流（所有活动的发起和助力）"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.trafficForm.trafficMode === "RATE"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "每秒上限" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, max: 100000, step: 50 },
                        model: {
                          value: _vm.trafficForm.trafficQps,
                          callback: function ($$v) {
                            _vm.$set(_vm.trafficForm, "trafficQps", $$v)
                          },
                          expression: "trafficForm.trafficQps",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "8px",
                            color: "#909399",
                          },
                        },
                        [_vm._v("所有活动发起+助力合计 QPS，默认 300")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "span",
                  { staticStyle: { color: "#909399", "font-size": "12px" } },
                  [
                    _vm._v(
                      "\n          全局一份配置，拦所有裂变的发起、助力。详情和领取不受影响。压测这两接口同样生效，压库存前请先关闭此配置。\n        "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.trafficDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.trafficSaving,
                  },
                  on: { click: _vm.submitTraffic },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.qrDialogVisible,
            width: "560px",
            "before-close": function () {
              return (_vm.qrDialogVisible = false)
            },
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "10px 0" } },
            [
              _vm.qrImage
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "18px",
                        "font-size": "24px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v(_vm._s(_vm.qrObj.activityName) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.qrImage
                ? _c("el-image", {
                    staticStyle: {
                      "max-width": "320px",
                      "max-height": "320px",
                    },
                    attrs: { src: _vm.qrImage, fit: "contain" },
                  })
                : _c("div", [_vm._v("暂无二维码图片")]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }